import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationEN from '@/assets/locales/en.json'
import translationES from '@/assets/locales/es.json'
import translationES_AR from '@/assets/locales/es_AR.json'
import translationsPT_BR from '@/assets/locales/pt_BR.json'

export const AVAILABLE_LANGUAGES = ['es', 'en', 'pt', 'es-AR', 'pt-BR']

export const SIMPLE_LANGUAGES = ['es', 'en', 'pt']

// the translations
const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  pt: { translation: translationsPT_BR },
  'es-AR': { translation: translationES_AR },
  'pt-BR': { translation: translationsPT_BR },
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'es',
    keySeparator: false,
    supportedLngs: AVAILABLE_LANGUAGES,
    returnEmptyString: false,
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
  })

const { t } = i18next

export { t }

export default i18next
